import { Link, SxProps } from "@mui/material";
import { Parameter } from "../../../common/types/parameters";
import { Column } from "../types";
import ParameterSection from "../parameter-section";
import {
  supplementalDistrictHeatingCostSummaryLccSections,
  supplementalDistrictHeatingLccSections,
} from "./supplemental-district-heating-lcc-sections";

export default function AirSourceHeatPump(params: {
  description?: string;
  printTitle: string;
  parameters: Parameter[];
  includeVat: boolean;
  toPrint: boolean;
  onValidParameterChange?: (id: string, value: string) => void;
  onSectionChange?: (targetTab: string) => void;
  sx?: SxProps;
}) {
  return (
    <ParameterSection
      printTitle={params.printTitle}
      description={params.description}
      parameters={params.parameters}
      columns={columns(params.onSectionChange)}
      toPrint={params.toPrint}
      includeVat={params.includeVat}
      onValidParameterChange={params.onValidParameterChange}
      sx={params.sx}
    />
  );
}

const columns = (onSectionChange: ((targetTab: string) => void) | undefined) =>
  [
    {
      sections: [
        {
          title: "Kostnader",
          parameters: [
            "AirSourceInvestmentLCCost",
            "AirSourceHeatPumpMaintenanceLCCost",
            "AirSourceEnergyLCCost",
            "AirSourceGridLCCostFixed",
            "AirSourceGridLCCostPower",
            "AirSourceGridLCCostVariable",
            "AirSourceGridElectricityTaxLCCost",
            "AirSourceReinvestmentLCCost",
          ],
        },
        ...supplementalDistrictHeatingCostSummaryLccSections("AirSource"),
      ],
      readOnly: true,
    },
    {
      description: (
        <>
          Prislistor kan justeras på den{" "}
          <Link
            href="#"
            onClick={() => {
              if (onSectionChange !== undefined) {
                onSectionChange("Common");
              }
            }}
          >
            Övergripande
          </Link>{" "}
          fliken.
        </>
      ),
      sections: [
        {
          title: "Detaljerade indata",
          parameters: [
            "AirSourceHeatingDesignLoad",
            "AirSourceHeatPumpLoadCoverage",
            "AirSourceHeatPumpEnergyCoverage",
            "AirSourceHeatPumpDeliveredHeatingLoad",
            "AirSourceRemainingHeatingLoad",
            "AirSourceHeatPumpSCOPRadiator",
            "AirSourceHeatPumpSCOPFloor",
          ],
        },
        {
          title: "Investeringskostnad",
          parameters: [
            "AirSourceEnergyWellCost",
            "AirSourceHeatPumpCost",
            "AirSourceMiscellaneousCost",
            "AirSourceInvestmentLCCost",
          ],
        },
        {
          title: "Reinvesteringskostnad",
          parameters: [
            "AirSourceReinvestmentCost",
            "AirSourceReinvestmentPeriod",
          ],
        },
        {
          title: "Drift- och underhållskostnader",
          parameters: ["AirSourceHeatPumpMaintenanceCost"],
        },
        ...supplementalDistrictHeatingLccSections("AirSource"),
      ],
    },
  ] as Column[];
